<template>
    <div class="marketStyle">
        <div class="row-four">主要宽基指数</div>
        <el-form :model="marketForm" class="form-one" :inline="true" label-position="right">
            <el-form-item label="选择时间：">
                <el-radio-group v-model="marketForm.time" class="radio-btnt" value-key="id" @change="timeChange">
                    <el-radio-button label="今年以来">今年以来</el-radio-button>
                    <el-radio-button label="近一月">近一月</el-radio-button>
                    <el-radio-button label="近三月">近三月</el-radio-button>
                    <el-radio-button label="近一年">近一年</el-radio-button>
                </el-radio-group>
            </el-form-item>
            <el-form-item>
                <el-date-picker type="date" class="date-picker-two ml20" :editable="false" placeholder="选择日期" v-model="marketForm.startDate" :clearable="false" @change="dateChange" value-format="yyyy-MM-dd"></el-date-picker> -
                <el-date-picker type="date" class="date-picker-two" :editable="false" placeholder="选择日期" v-model="marketForm.endDate" :clearable="false" @change="dateChange" value-format="yyyy-MM-dd"></el-date-picker>
            </el-form-item>
        </el-form>
        <div id="scfg" style="margin: 0 0 30px;width: 1120px;height: 316px;"></div>
        <el-row class="row-two"><h3 class="title">相关性</h3></el-row>
        <table class="strategy-table mt20" cellspacing="0">
            <tr>
                <th></th>
                <th v-for="(val,h) in indexArr" :key="h+'h'">{{val}}</th>
            </tr>
            <tr v-for="(item1,i1) in tabledata" :key="i1+'h'">
                <td>{{indexArr[i1]}}</td>
                <td v-for="(item2,i2) in item1" :key="i2+'d'" :style="classObj(item2)">{{parseFloat(item2).toFixed(4)}}</td>
            </tr>
        </table>
        <div class="row-aline mt70">
            <div>
                <div class="row-four">宽基指数偏移率</div>
                <div class="chart" id="jkpyl"></div>
            </div>
            <div>
                <div class="row-four">偏移分位数统计分析</div>
                <div class="chart" id="pyfws"></div>
            </div>
        </div>
        <div class="row-four mt50">申万风格指数</div>
        <el-form :model="swForm" class="form-one" :inline="true" label-position="right">
            <el-form-item label="选择时间：">
                <el-radio-group v-model="swForm.time" class="radio-btnt" value-key="id" @change="swTimeChange">
                    <el-radio-button label="今年以来">今年以来</el-radio-button>
                    <el-radio-button label="近一月">近一月</el-radio-button>
                    <el-radio-button label="近三月">近三月</el-radio-button>
                    <el-radio-button label="近一年">近一年</el-radio-button>
                </el-radio-group>
            </el-form-item>
            <el-form-item>
                <el-date-picker type="date" class="date-picker-two ml20" :editable="false" placeholder="选择日期" v-model="swForm.startDate" :clearable="false" @change="swDateChange" value-format="yyyy-MM-dd"></el-date-picker> -
                <el-date-picker type="date" class="date-picker-two" :editable="false" placeholder="选择日期" v-model="swForm.endDate" :clearable="false" @change="swDateChange" value-format="yyyy-MM-dd"></el-date-picker>
            </el-form-item>
        </el-form>
        <div class="row-aline">
            <div class="chart" id="swqx" style="width: 662px"></div>
            <div class="chart" id="swzs" style="width: 458px"></div>
        </div>
        <div class="row-four">国证风格指数</div>
        <el-form :model="gzForm" class="form-one" :inline="true" label-position="right">
            <el-form-item label="选择时间：">
                <el-radio-group v-model="gzForm.time" class="radio-btnt" value-key="id" @change="gzTimeChange">
                    <el-radio-button label="今年以来">今年以来</el-radio-button>
                    <el-radio-button label="近一月">近一月</el-radio-button>
                    <el-radio-button label="近三月">近三月</el-radio-button>
                    <el-radio-button label="近一年">近一年</el-radio-button>
                </el-radio-group>
            </el-form-item>
            <el-form-item>
                <el-date-picker type="date" class="date-picker-two ml20" :editable="false" placeholder="选择日期" v-model="gzForm.startDate" :clearable="false" @change="gzDateChange" value-format="yyyy-MM-dd"></el-date-picker> -
                <el-date-picker type="date" class="date-picker-two" :editable="false" placeholder="选择日期" v-model="gzForm.endDate" :clearable="false" @change="gzDateChange" value-format="yyyy-MM-dd"></el-date-picker>
            </el-form-item>
        </el-form>
        <div class="row-aline">
            <div class="chart" id="gzqx" style="width: 662px"></div>
            <div class="chart" id="gzzs" style="width: 458px"></div>
        </div>
        <div class="row-four">中信风格指数</div>
        <el-form :model="zxForm" class="form-one" :inline="true" label-position="right">
            <el-form-item label="选择时间：">
                <el-radio-group v-model="zxForm.time" class="radio-btnt" value-key="id" @change="zxTimeChange">
                    <el-radio-button label="今年以来">今年以来</el-radio-button>
                    <el-radio-button label="近一月">近一月</el-radio-button>
                    <el-radio-button label="近三月">近三月</el-radio-button>
                    <el-radio-button label="近一年">近一年</el-radio-button>
                </el-radio-group>
            </el-form-item>
            <el-form-item>
                <el-date-picker type="date" class="date-picker-two ml20" :editable="false" placeholder="选择日期" v-model="zxForm.startDate" :clearable="false" @change="zxDateChange" value-format="yyyy-MM-dd"></el-date-picker> -
                <el-date-picker type="date" class="date-picker-two" :editable="false" placeholder="选择日期" v-model="zxForm.endDate" :clearable="false" @change="zxDateChange" value-format="yyyy-MM-dd"></el-date-picker>
            </el-form-item>
        </el-form>
        <div class="row-aline">
            <div class="chart" id="zxqx" style="width: 662px"></div>
            <div class="chart" id="zxzs" style="width: 458px"></div>
        </div>
    </div>
</template>

<script>
export default {
    name: "marketStyle",
    data() {
        return {
            indexArr: ['上证50','沪深300','中证500','中证1000','国证2000'],
            tabledata: [],
            marketForm: {
                time: '今年以来',
                startDate: '',
                endDate: '',
            },
            swForm: {
                time: '今年以来',
                startDate: '',
                endDate: '',
            },
            gzForm: {
                time: '今年以来',
                startDate: '',
                endDate: '',
            },
            zxForm: {
                time: '今年以来',
                startDate: '',
                endDate: '',
            },
        }
    },
    computed: {
        classObj(state) {
            return (state) => {
                if(state >= -1 && state < -0.5) {
                    return { background: '#95B8C9' }
                } else if(state >= -0.5 && state < 0) {
                    return { background: '#80AABF' }
                } else if(state >= 0 && state < 0.4) {
                    return { background: '#679AB2' }
                } else if(state >= 0.4 && state < 0.6) {
                    return { background: '#4D88A5' }
                } else if(state >= 0.6 && state < 0.8) {
                    return { background: '#1A678C' }
                } else if(state >= 0.8 && state <= 1) {
                    return { background: '#024B6E' }
                }
            }
        },
    },
    mounted() {
        this.marketForm.startDate = new Date().getFullYear()+'-01-01'
        this.marketForm.endDate = this.$commonJs.timeFormat(new Date(),'yyyy-mm-dd')
        this.getMarketStyleIndex()
        this.swForm.startDate = new Date().getFullYear()+'-01-01'
        this.swForm.endDate = this.$commonJs.timeFormat(new Date(),'yyyy-mm-dd')
        this.getMarketStyleIndexCharts('swfg')
        this.gzForm.startDate = new Date().getFullYear()+'-01-01'
        this.gzForm.endDate = this.$commonJs.timeFormat(new Date(),'yyyy-mm-dd')
        this.getMarketStyleIndexCharts('gzfg')
        this.zxForm.startDate = new Date().getFullYear()+'-01-01'
        this.zxForm.endDate = this.$commonJs.timeFormat(new Date(),'yyyy-mm-dd')
        this.getMarketStyleIndexCharts('zxfg')
        this.getMarketStyleRelatedIndex()
        this.getIndexDeviationCharts()
    },
    methods: {
        // 市场风格
        getMarketStyleIndex() {
            let vm = this
            vm.$http.post(vm.$apiPath.GetMarketStyleIndex, {
                StartDate: this.marketForm.startDate,
                EndDate: this.marketForm.endDate,
            }).then(res => {
                // console.log(res);
                if (res.data.code == 200) {
                    let series = []
                    res.data.data.nameList.forEach((item,i) => {
                        series.push({
                            name:item,
                            type:'line',symbol:'circle',showSymbol: false,symbolSize:8,
                            data:res.data.data.dataList[i]
                        })
                    })
                    vm.$commonEcharts.echartsSix('scfg', res.data.data.dateList, series)
                }
            }).catch(err => {})
        },
        dateChange() {
            let vm = this
            vm.marketForm.time='';
            vm.getMarketStyleIndex();
            vm.getMarketStyleRelatedIndex()
        },
        timeChange(val) {
            let vm = this
            let obj = this.time(val)
            this.marketForm.startDate = obj.start
            this.marketForm.endDate = obj.end
            vm.getMarketStyleIndex()
            vm.getMarketStyleRelatedIndex()
        },
        // 相关性
        getMarketStyleRelatedIndex() {
            let vm = this
            vm.$http.post(vm.$apiPath.GetMarketStyleRelatedIndex, {
                StartDate: vm.marketForm.startDate,
                EndDate: vm.marketForm.endDate,
            }).then(res => {
                // console.log(res);
                if (res.data.code == 200) {
                    vm.tabledata = res.data.data
                }
            }).catch(err => {})
        },
        getMarketStyleIndexCharts(type) {
            let vm = this
            let color = ['#B81616','#E48A0A','#EDC718','#7DBA1C','#22A1CB','#C053E0','#794AC0','#1C6ABA','#F05BB6',]
            if(type == 'swfg') {
                vm.$http.post(vm.$apiPath.GetMarketStyleIndexCharts, {
                    Type: '1',//1表示申万风格指数；2表示国证风格指数；3表示中信风格指数
                    StartDate: vm.swForm.startDate,
                    EndDate: vm.swForm.endDate,
                }).then(res => {
                    // console.log(res);
                    if (res.data.code == 200) {
                        let lineSeries1 = [],leiSeries1 = [],termData1 = []
                        res.data.data.nameList.forEach((item,i) => {
                            lineSeries1.push({
                                name:item,
                                type:'line',symbol:'circle',showSymbol: false,symbolSize:8,
                                data:res.data.data.dataList[i]
                            })
                        })
                        for(let i = 0; i < res.data.data.yieldList.length; i++) {
                            leiSeries1.push(Number(res.data.data.yieldList[i].yield*100).toFixed(2))
                        }
                        res.data.data.yieldList.forEach(val => {
                            termData1.push({
                                name:val.secuNameAbbr,
                                max: Math.max.apply(null,leiSeries1) + 5,
                                min: Math.min.apply(null,leiSeries1) - 5
                            })
                        })
                        vm.$commonEcharts.echartsSix('swqx', res.data.data.dateList, lineSeries1,false,color)
                        vm.$commonEcharts.echartsNormalRadar('swzs',termData1,leiSeries1,90)
                    }
                }).catch(err => {})
            } else if(type == 'gzfg') {
                vm.$http.post(vm.$apiPath.GetMarketStyleIndexCharts, {
                    Type: '2',
                    StartDate: vm.gzForm.startDate,
                    EndDate: vm.gzForm.endDate,
                }).then(res => {
                    // console.log(res);
                    if (res.data.code == 200) {
                        let lineSeries2 = [],leiSeries2 = [],termData2 = []
                        res.data.data.nameList.forEach((item,i) => {
                            lineSeries2.push({
                                name:item,
                                type:'line',symbol:'circle',showSymbol: false,symbolSize:8,
                                data:res.data.data.dataList[i]
                            })
                        })
                        for(let i = 0; i < res.data.data.yieldList.length; i++) {
                            leiSeries2.push(Number(res.data.data.yieldList[i].yield*100).toFixed(2))
                        }
                        res.data.data.yieldList.forEach(val => {
                            termData2.push({
                                name:val.secuNameAbbr,
                                max: Math.max.apply(null,leiSeries2) + 5,
                                min: Math.min.apply(null,leiSeries2) - 5
                            })
                        })
                        vm.$commonEcharts.echartsSix('gzqx', res.data.data.dateList, lineSeries2,false,color)
                        vm.$commonEcharts.echartsNormalRadar('gzzs',termData2,leiSeries2,90)
                    }
                }).catch(err => {})
            } else if(type == 'zxfg') {
                vm.$http.post(vm.$apiPath.GetMarketStyleIndexCharts, {
                    Type: '3',
                    StartDate: vm.zxForm.startDate,
                    EndDate: vm.zxForm.endDate,
                }).then(res => {
                    // console.log(res);
                    if (res.data.code == 200) {
                        let lineSeries3 = [],leiSeries3 = [],termData3 = []
                        res.data.data.nameList.forEach((item,i) => {
                            lineSeries3.push({
                                name:item,
                                type:'line',symbol:'circle',showSymbol: false,symbolSize:8,
                                data:res.data.data.dataList[i]
                            })
                        })
                        for(let i = 0; i < res.data.data.yieldList.length; i++) {
                            leiSeries3.push(Number(res.data.data.yieldList[i].yield*100).toFixed(2))
                        }
                        res.data.data.yieldList.forEach(val => {
                            termData3.push({
                                name:val.secuNameAbbr,
                                max: Math.max.apply(null,leiSeries3) + 5,
                                min: Math.min.apply(null,leiSeries3) - 5
                            })
                        })
                        vm.$commonEcharts.echartsSix('zxqx', res.data.data.dateList, lineSeries3,false,color)
                        vm.$commonEcharts.echartsNormalRadar('zxzs',termData3,leiSeries3,90)
                    }
                }).catch(err => {})
            }
        },
        time(type) {
            let form = {start: '',end: '',}
            if(type == '近一月') {
                form.start = this.$commonJs.getBeforeDate(-30)
            } else if(type == '近三月') {
                form.start = this.$commonJs.getBeforeDate(-90)
            } else if(type == '近一年') {
                form.start = this.$commonJs.getBeforeDate(-365)
            } else if(type == '今年以来') {
                form.start = new Date().getFullYear()+'-01-01'
            }
            form.end = this.$commonJs.timeFormat(new Date(),'yyyy-mm-dd')
            return form
        },
        swTimeChange(val) {
            let obj = this.time(val)
            this.swForm.startDate = obj.start
            this.swForm.endDate = obj.end
            this.getMarketStyleIndexCharts('swfg')
        },
        swDateChange() {
            this.swForm.time='';
            this.getMarketStyleIndexCharts('swfg')
        },
        gzTimeChange(val) {
            let obj = this.time(val)
            this.gzForm.startDate = obj.start
            this.gzForm.endDate = obj.end
            this.getMarketStyleIndexCharts('gzfg')
        },
        gzDateChange() {
            this.gzForm.time='';
            this.getMarketStyleIndexCharts('gzfg')
        },
        zxTimeChange(val) {
            let obj = this.time(val)
            this.zxForm.startDate = obj.start
            this.zxForm.endDate = obj.end
            this.getMarketStyleIndexCharts('zxfg')
        },
        zxDateChange() {
            this.zxForm.time='';
            this.getMarketStyleIndexCharts('zxfg')
        },
        getIndexDeviationCharts() {
            let vm = this
            vm.$http.post(vm.$apiPath.GetIndexDeviationCharts, {}).then(res => {
                // console.log(res);
                if (res.data.code == 200) {
                    let xdata = res.data.data.list
                    let seriesLine = [],  seriesBar = []
                    xdata[0].nameList.forEach((item1,i1) => {
                        seriesLine.push({
                            name:item1,
                            type:'line',symbol:'circle',showSymbol: false,symbolSize:8,
                            data:xdata[0].dataList[i1],
                            areaStyle:{opacity:1},
                        })
                    })
                    this.$commonEcharts.echartsSix('jkpyl',xdata[0].dateList,seriesLine,false,['#5980b7'])
                    xdata[1].nameList.forEach((item2,i2) => {
                        seriesBar.push({
                            name:item2,
                            type:'bar',barMaxWidth: 20,
                            data:xdata[1].dataList[i2],
                        })
                    })
                    this.$commonEcharts.echartsSix('pyfws',xdata[1].dateList,seriesBar,false,['#5980b7'],true)//01567F
                }
            }).catch(err => {})
        },
    }
}
</script>

<style scoped lang="less">
.marketStyle {
    .row-aline {margin: 20px 0 50px;display: flex;justify-content: space-between;}
    .chart {width: 509px;height: 316px;}
    /deep/.el-radio-button {margin-right: 20px;}
    /* 表格 */
    .strategy-table{
        tr {
            th {min-width: 85px;}
            td {color: @whiteColor;}
            td:first-child {color:@mainColor;background:@oColor4;}
        }
        tr:first-child {color:@mainColor;background:@oColor4;}
    }
}
</style>
